import { AlenDevice } from "src/interfaces/IAlenDevice";
import {
  findProductFunctions,
  getAlenDeviceShadow,
  getAlenProductFunctions,
  ShadowField,
  ShadowFields,
} from "../alenDeviceConfig/utils";
import alenProductConfig from "../alenDeviceConfig";

export const getWritableDeviceFunctions = (device: AlenDevice) => {
  const shadow = getAlenDeviceShadow(device, alenProductConfig);
  const standardNames = ShadowFields.filter((key) => shadow[key] !== undefined);

  const standardFunctions = standardNames.map((name) =>
    findProductFunctions(
      getAlenProductFunctions(device.product_id, alenProductConfig),
      name
    )
  );
  const rwStandardFunctions = standardFunctions.filter(
    (sf) => sf.mode === "rw"
  );
  return rwStandardFunctions.map((sf) => sf.standardName as ShadowField);
};

const getCommonFunctionValues = (
  devices: AlenDevice[],
  standardName: ShadowField,
  includeCurrent: boolean = false
) => {
  // Get all standard values for the given standard name across all devices
  const functionOptions = devices.map((device) => {
    const standardFunctions = findProductFunctions(
      getAlenProductFunctions(device.product_id, alenProductConfig),
      standardName
    );
    const { standardValues } = standardFunctions;
    return standardValues
      ? standardValues.flatMap((sv) => Object.keys(sv))
      : [];
  });

  // Find common values across all devices
  const commonValues = functionOptions.reduce(
    (acc, curr) => acc.filter((value) => curr.includes(value)),
    functionOptions[0]
  );

  // Filter out current values if includeCurrent is false
  const usableValues = devices.flatMap((device) => {
    const shadow = getAlenDeviceShadow(device, alenProductConfig);
    return includeCurrent
      ? commonValues
      : commonValues.filter((value) => shadow[standardName] !== value);
  });

  // Remove duplicates and return the result
  return Array.from(new Set(usableValues));
};

// Get Common Performable Actions and their options from given devices
export const getCommonActions = (
  devices: AlenDevice[],
  includeCurrentOptions: boolean = false
) => {
  const deviceStandardNames = devices.map((device) =>
    getWritableDeviceFunctions(device)
  );
  const commonFunctions = deviceStandardNames.reduce(
    (acc, curr) => acc.filter((value) => curr.includes(value)),
    deviceStandardNames[0]
  );
  const formOptions = commonFunctions.map((standardName) => ({
    standardName,
    options: getCommonFunctionValues(
      devices,
      standardName,
      includeCurrentOptions
    ),
  }));
  return formOptions;
};
